/** The pace of a few frames is needed before any estimate is honest. */
const MIN_FRAMES = 5;
/** A whole run longer than this is a slow device: say so, and that the page must stay open. */
const SLOW_TOTAL_MS = 90_000;

/**
 * How long the on-device analysis has left, from the pace so far, and whether this device is slow (owner, 2026-10-18
 * onboarding plan). Null until a few frames have set the pace.
 */
export function extractionEta(framesDone: number, totalFrames: number, elapsedMs: number): { timeLeft: string | null; slow: boolean } {
  if (framesDone < MIN_FRAMES || totalFrames <= 0 || elapsedMs <= 0) return { timeLeft: null, slow: false };
  const perFrame = elapsedMs / framesDone;
  const leftMs = Math.max(0, (totalFrames - framesDone) * perFrame);
  const slow = perFrame * totalFrames > SLOW_TOTAL_MS;
  if (leftMs < 3000) return { timeLeft: "almost done", slow };
  const leftSec = leftMs / 1000;
  if (leftSec <= 90) return { timeLeft: `about ${Math.max(5, Math.round(leftSec / 10) * 10)} s left`, slow };
  return { timeLeft: `about ${Math.round(leftSec / 60)} min left`, slow };
}
